import React, { useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function CreatorCard({ submission }) {
  const [likes, setLikes] = useState(submission.likes);
  const [clicks, setClicks] = useState(submission.clicks);

  const handleLike = async () => {
    try {
      await axios.patch(`${API_BASE}/submissions/${submission._id}/like`);
      setLikes(prev => prev + 1);
    } catch (err) {
      alert('Failed to like');
    }
  };

  const handleVisit = () => {
    window.open(submission.kofi_url, '_blank');
  
    axios.patch(`${API_BASE}/submissions/${submission._id}/click`)
      .then(() => setClicks(prev => prev + 1))
      .catch(err => console.error('Failed to track click'));
  };  

  return (
    <div style={{
      border: '1px solid #ddd',
      padding: '15px',
      borderRadius: '8px',
      background: '#fff',
      boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
      textAlign: 'center',
      fontFamily: "'Nunito', sans-serif"
    }}>
      
      {submission.avatar_url && (
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          border: '4px solid #4dabf7',
          overflow: 'hidden',
          margin: '0 auto 10px'
        }}>
          <img
            src={submission.avatar_url}
            alt="Creator avatar"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>
      )}

      <h3 style={{ margin: '10px 0 5px' }}>{submission.name}</h3>

      <p style={{ fontSize: '0.9rem', color: '#555', marginBottom: '8px' }}>
        {submission.description}
      </p>

      {/* Display Categories as cute badges */}
      {submission.categories && submission.categories.length > 0 && (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '6px',
          marginBottom: '10px',
          marginTop: '8px',
        }}>
          {submission.categories.map((category, index) => (
            <span key={index} style={{
              backgroundColor: '#e3f2fd',
              color: '#333',
              padding: '4px 10px',
              borderRadius: '20px',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              whiteSpace: 'nowrap'
            }}>
              {category}
            </span>
          ))}
        </div>
      )}

      <button
        onClick={handleVisit}
        style={{
          display: 'inline-block',
          marginTop: '8px',
          padding: '6px 12px',
          backgroundColor: '#4dabf7',
          color: 'white',
          borderRadius: '20px',
          textDecoration: 'none',
          fontSize: '0.85rem',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        Visit Ko-fi
      </button>

      <div style={{ fontSize: '0.8rem', color: '#888', marginTop: '8px' }}>
        <span
          style={{ cursor: 'pointer', marginRight: '10px' }}
          onClick={handleLike}
        >
          ❤️ {likes}
        </span>
        <span>👀 {clicks}</span>
      </div>
    </div>
  );
}

export default CreatorCard;




